<template>
  <el-table
    :data="tableData"
    :header-cell-style="tableHeader"
    :max-height="tableHeight"
    border
    v-loading="loadingtable"
    element-loading-text="拼命加载中请稍后..."
    element-loading-spinner="el-icon-loading"
  >
    <!--    :max-height="maxTableHeight"-->
    <el-table-column
      v-for="(item,index) in fieldArr"
      :key="index"
      :prop="item.name"
      :label="item.label"
    >
      <template v-slot="{ row }">
          <span v-if="timerFormat.includes(item.name)">
            <!--    格式化时间      -->
            {{row[item.name] | formatData}}
          </span>
        <span v-else-if="toFixedFormat.includes(item.name)">
            <!--    保留两位小数      -->
            {{row[item.name] | toFixedex}}
        </span>
        <span v-else-if="percentFormat.includes(item.name)">
            <!--    百分比格式化      -->
            {{row[item.name] | toPercentFormat}}
        </span>
        <span
          v-cust
          v-else-if="linkArray.includes(item.name)"
          class="theme-blue"
          @click="goClassDetail(item,row)"
        >
          {{row[item.name]}}
        </span>
        <span
          v-cust
          v-else-if="item.type === 'handler'"
          class="theme-blue"
          @click="item.clickNode(item,row)"
        >
          {{item.name}}
        </span>
        <span v-else>
          {{item.formatter ? item.formatter.call(this,row[item.name],row) : row[item.name] || '--'}}
        </span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'infoTable',
  data () {
    return {
      loadingtable: true,
      linkArray: ['proType', 'contractCode', 'cusName']
    }
  },
  mounted () {
    setTimeout(() => {
      this.loadingtable = false
    }, 500)
  },
  watch: {
    tableData () {
      const {
        tableData
      } = this
      this.loadingtable = false
      return tableData
    }
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    fieldArr: {
      type: Array,
      default: () => []
    },
    staticArray: {
      type: Array,
      default: () => ['static_type']
    },
    // 格式化时间
    timerFormat: {
      type: Array,
      default: () => ['ocUnitDate', 'createDate', 'signDate', 'updateDate']
    },
    // 保留两位小数
    toFixedFormat: {
      type: Array,
      default: () => (
        [
          'ocPrice',
          'ocTotal',
          'ocAgreementPrice',
          'ocHistoryPrice',
          'ocUnitPrice',
          'ocUnitTotal',
          'ocFacePrice',
          'orderTotal',
          'orderCost',
          'cbTotal',
          'cbPrice',
          'cbUnitPrice',
          'cbUnitTotal',
          'cbFacePrice',
          'purchaseUnitPrice',
          'taxAmount',
          'contractTotal',
          'stockupUnPrice',
          'contractAc',
          'accountsDue',
          'forfeitureProice'
        ]
      )
    },
    // 格式化百分比
    percentFormat: {
      type: Array,
      default: () => (
        [
          'ocRate',
          'ocDiscount',
          'orderRate',
          'cbRate',
          'contractRate',
          'cbDiscount',
          'taxRat',
          'point',
          'forfeiturePenalty'
        ]
      )
    },
    tableHeight: {
      type: String,
      default: '378'
    },
    maxTableHeight: {
      type: String,
      default: 'auto'
    }
  },
  filters: {
    toFixedex (n) {
      if (!n && n !== 0) return '--'
      if (n === 0 || n === '0') return '0.00'
      return n.toFixed(2)
    },
    toPercentFormat (n) {
      const nex = Number(n) ? n : 0
      return (nex * 100).toFixed(2) + '%'
    }
  },
  methods: {
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    goClassDetail (item, row) {
      const { name } = item
      switch (name) {
        case 'proType':
          // 型号
          this.$router.push({
            name: 'productDetails',
            query: {
              id: row.proId || row.id
            }
          })
          break
        case 'contractCode':
          // 合同编号
          if (row.signState === 4 || row.signState === 5) {
            this.$router.push({
              name: 'contractEdit',
              query: {
                id: row.id,
                cusId: row.cusId
              }
            })
            return
          }
          this.$router.push({
            name: 'contractCreate',
            query: {
              id: row.id,
              cusId: row.cusId
            }
          })
          break
        case 'cusName':
          // 客户
          this.$router.push({
            name: 'customer/details',
            query: { id: row.cusId }
          })
          break
      }
    }
  }
}
</script>

<style scoped>

</style>
